<template>
  <transition name="slide-fade">
    <div class="login">
      <div class="login-bg loginBackground" />
      <transition name="slide-fade">
        <main class="main">
          <img
            src="../assets/images/logo-full-mono-light.png"
            alt=""
          >
          <h1>Reset password</h1>
          <div
            v-if="token"
            class="box row"
          >
            <transition name="slide-fade">
              <div
                v-if="serverError"
                class="alert alert-danger col"
                role="alert"
              >
                {{ serverError }}
              </div>
            </transition>
            <password
              class="col-12"
              :new-password.sync="password"
              :confirm-password.sync="passwordConfirm"
              @passwordValidation="validPassword=$event.isValid"
            />
            <div class="col-12 text-center mt-4">
              <b-button
                :disabled="!validPassword"
                type="button"
                variant="primary"
                class="loading col-6"
                @click.prevent="postPasswordReset"
              >
                Reset
              </b-button>
            </div>
          </div>
          <div
            v-if="!token"
            class="box row"
          >
            <div
              class="alert alert-danger col-12"
              role="alert"
            >
              Could not parse token
            </div>
          </div>
        </main>
      </transition>
    </div>
  </transition>
</template>

<script>
import Password from '@/components/Password.vue'
import moment from 'moment'
import { Notification, NOTIFICATION_STYLES } from '@microbadevs/library'

export default {
  name: 'ResetPassword',
  components: {
    Password
  },
  data () {
    return {
      password: '',
      passwordConfirm: '',
      validPassword: false
    }
  },
  computed: {
    token: function () {
      return Object.keys(this.$route.query)[0]
    },
    serverError: function () {
      return this.$store.state.POST_PASSWORD_RESET_FAILURE
        ? 'Could not reset password'
        : null
    }
  },
  mounted () {
    this.validateToken()
  },
  methods: {
    validateToken () {
      const token = this.$jwt.decode(this.token)
      const isScopeCorrect = token.scope.indexOf('reset-password') >= 0
      const isTokenExpired = token.exp - moment().unix() <= 0
      if (isScopeCorrect && !isTokenExpired) return
      let resetPasswordTokenError
      if (!isScopeCorrect) resetPasswordTokenError = 'The reset password token is invalid, please click reset password and try again.'
      if (isTokenExpired) resetPasswordTokenError = 'The reset password token is expired, please click reset password and try again.'
      this.$router.push({ name: 'Login', params: { resetPasswordTokenError } })
    },
    postPasswordReset () {
      if (!this.validPassword) return
      this.$store
        .dispatch('postPasswordReset', {
          token: this.token,
          password: this.password
        })
        .then(success => {
          this.$router.push({ name: 'Login' })
        })
        .catch(error => {
          Notification({
            title: 'Failed',
            text: error?.response?.data?.message || error.message,
            style: NOTIFICATION_STYLES.ERROR
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
  body {
    background: white;
    font-family: Roboto, sans-serif !important;
    font-size: 0.875rem;
    font-weight: lighter;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
  }

  .login .page-report-single h2,
  .login h1,
  .page-report-single .login h2 {
    color: #fff;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .page-report-single h2,
    h1 {
      font-size: 3rem;
    }
  }

  input,
  textarea,
  select,
  button {
    text-rendering: auto;
    color: initial;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    margin: 0em;
    font: 400 11px system-ui;
  }
  .page-report-single h2,
  h1 {
    font-family: athelas, serif;
    font-weight: 600;
    font-size: 2.25rem;
    margin: 1rem 0;
    color: #00193d;
    letter-spacing: 1px;
  }

  .login .main {
    box-shadow: none;
    width: 100%;
    min-height: 500px;
    min-width: 290px;
    max-width: calc(100% - 4rem);
  }

  @media (min-width: 768px) {
    .login .main {
      max-width: 620px !important;
    }
  }

  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 100%;
    width: 100%;
    position: relative;
    padding: 2rem 0;
  }

  .login-bg {
    background: url('../assets/images/bg-dashboard-img.jpg') no-repeat 50% !important;
    background-size: cover;
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .login .main {
    box-shadow: none;
    width: 100%;
    min-height: 500px;
    min-width: 290px;
    max-width: calc(100% - 4rem);
  }

  .login .page-report-single h2,
  .login h1,
  .page-report-single .login h2 {
    color: #fff;
    margin-bottom: 1.5rem;
  }

  .page-report-single h2,
  h1 {
    font-family: athelas, serif;
    font-weight: 600;
    margin: 1rem 0;
    letter-spacing: 1px;
  }

  @media (min-width: 768px) {
    .login .box {
      padding: 41px 41px 21px;
    }
  }
  .login footer {
    text-align: center;
    font-size: 12px;
  }

  .additional-info p {
    color: #00193d;
    font-size: 1rem;
    font-weight: 300;
  }

  .login .box {
    padding: 1.75rem 1.5rem 0;
  }

  .box {
    padding: 1rem;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 2rem;
  }

  @media (min-width: 768px) {
    .input-icon ~ input {
      padding-left: 50px;
    }
  }

  input {
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: 16px 18px;
    background-position: 98% 50%;
    cursor: auto;
  }

  .input-icon {
    position: absolute;
    width: 30px;
    height: 46px;
    z-index: 100;
  }

  .input-icon ~ input {
    padding-left: 40px;
  }
  .form-control {
    color: #00193d;

    font-size: 1rem;
    font-weight: 300;
    transition: background 0.3s ease-out, border 0.4s ease;
    padding: 1.4rem 1rem 1.4rem;
  }

  .btn,
  .btn-select .v-select,
  button {
    cursor: pointer;
    font-family: Roboto, sans-serif;
    font-size: 1rem;
    text-align: center;
    color: #fff;
  }

  .btn-dynamic {
    transition: all 0.1s;
    outline: none;
    overflow: hidden;
    min-width: 150px;
    position: relative;
    height: 42px;
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
    z-index: 2;
    width: 100%;
    max-width: 300px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 768px) {
    .login button.plain {
      width: auto !important;
    }
  }

  .login button.plain {
    float: right;
  }
  .btn-select .plain.v-select,
  .btn.plain,
  button.plain {
    color: #ff8708;
    padding: 0;
    background: transparent;
    border: none;
    font-size: 1rem;
    font-weight: 500;
    outline: 0;
    box-shadow: none;
  }

  .additional-info p a {
    font-weight: 500;
    color: #ff8708 !important;
    cursor: pointer;
  }

  a {
    color: #ff8708;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  .form-checkbox label,
  .form-radio label {
    cursor: pointer;
    font-weight: 300;
    color: #778598;
    padding-left: 30px;
    margin-bottom: 1rem;
  }

  .form-checkbox,
  .form-checkbox label,
  .form-radio,
  .form-radio label {
    position: relative;
    font-size: 1rem;
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
  }

  .radio-wrapper-outer {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem 0rem 1rem 0rem;

    @media (min-width: 768px) {
      justify-content: flex-start;
      padding: 0;
    }
  }

  .radio-wrapper-inner {
    display: block;
  }

  .forgot-password {
    .row.suplimentary {
      padding-top: 1.5rem;

      @media (min-width: 768px) {
        padding-top: 0;
      }
    }
  }

  .input-icon .faw {
    color: #778598;
    padding: 0 7px;
    margin: 1px 1px 1px 5px;
    line-height: 40px;
    font-size: 1rem;
  }

  .text-orange {
    color: #ff8708 !important;
  }

  .loginBackground {
    background: url(/img/bg-dashboard-img.c6142a06.jpg) no-repeat center center
      fixed !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
  }
</style>
